import { createVNode as r, mergeProps as a } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/DisconnectedTwotoneStandard.js";
import c from "../components/PfIcon.js";
const t = (o, e) => {
  const n = {
    ...o,
    ...e.attrs
  };
  return r(c, a(n, {
    icon: d
  }), null);
};
t.displayName = "DisconnectedTwotoneStandard";
t.inheritAttrs = !1;
export {
  t as default
};
